function formatCurrency (price, locale) {
  // accepts prices to 2d.p format (e.g. 5.99) locale as ISO or currency symbol
  const currencyMap = {
    'es-ES': { symbol: '€', iso: 'EUR' },
    'en-US': { symbol: '$', iso: 'USD' },
    'en-CA': { symbol: '$', iso: 'CAD' },
    'en-GB': { symbol: '£', iso: 'GBP' }
  }
  const currencyCode = Object.keys(currencyMap).find(key => {
    return currencyMap[key].iso === locale || currencyMap[key].symbol === locale
  })
  let formattedPrice
  if (currencyCode) {
    formattedPrice = new Intl.NumberFormat(currencyCode, { style: 'currency', currency: currencyMap[currencyCode].iso }).format(price)
  } else {
    // If no match in currencyMap, default to USD format
    formattedPrice = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price)
  }
  return formattedPrice
}

export function priceString (variant) {
  if (!variant || !variant.price) {
    return ''
  }
  const supaduCurrencyIso = window.theme.settings.supaduCurrency.currency_iso
  const supaduCurrencySymbol = window.theme.settings.supaduCurrency.currency_symbol
  const variantPrice = (variant.price / 100).toFixed(2)
  const regularPrice = formatCurrency(variantPrice, supaduCurrencyIso || supaduCurrencySymbol)
  const discount = variant.compare_at_price !== null ? `
  <span class="price__discount">
    <strike>
      ${formatCurrency(variant.compare_at_price.toFixed(2) / 100, supaduCurrencyIso || supaduCurrencySymbol)}
    </strike>
  </span>` : ''
  return `${regularPrice}${discount}`
}

export function getPriceSection () {
  let priceSection = ''
  if (!window.theme.productData || !window.theme.productData.variants || !window.theme.productData.variants.length) {
    return priceSection
  }
  window.theme.productData.variants.forEach((variant) => {
    priceSection += `<p class="price__main">${priceString(variant)}</p>`
  })
  priceSection = `<div class='price__section'>${priceSection}</div>`

  return priceSection
}

export function getSupafolioPrice (item) {
  if (!item.prices || !window.theme.settings.bookDetailsSettings) {
    return ''
  }
  let currencies = 'USD'
  if (window.theme.settings.bookDetailsSettings.price_currencies) currencies = window.theme.settings.bookDetailsSettings.price_currencies
  currencies = currencies.replace(/\s/g, '').split(',')

  return item.prices.filter((price) => {
    return currencies.includes(price.locale)
  }).map((price) => {
    return formatCurrency(price.amount, price.locale)
  }).join(' / ')
}
